export default "__VITE_ASSET__CDUKrap$__"